module.exports = __webpack_public_path__ + "img/wap_font@2x.0b35ac51.png";